import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/TravelExpenseTable.html?raw';
import TravelExpenseList from '../Main/TravelExpenseList';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// NOTE (JS2TS): dropped dead dojo deps (dom-attr, dom-style, _base/connect). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class TravelExpenseTable extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entitylist: any = [];

    _setDataAttr(entitylist: any): void {

        console.debug("travelexpensetable setdata", entitylist);

        this.entitylist = entitylist;

        this.drawTable();
    }

    drawTable(): void {
        domConstruct.empty(this.tableContainer);

        let table = this.tableContainer;
        let heading = domConstruct.create("tr", {
            "className": ""
        }, table);
        //let colHeadAssociate = domConstruct.create("th", {
        //    innerHTML: "Mitarbeiter:"
        //}, heading);
        let colHeadProject = domConstruct.create("th", {
            innerHTML: "Projekt"
        }, heading);
        let colHeadType = domConstruct.create("th", {
            innerHTML: "Art"
        }, heading);
        let colHeadKm = domConstruct.create("th", {
            innerHTML: "km"
        }, heading);

        let sumKm = 0;

        for (let i = 0; i < this.entitylist.length; i++) {
            let entity = this.entitylist[i];

            let row = domConstruct.create("tr", {}, table);

            //let colAssociate = domConstruct.create("td", {
            //    innerHTML: entity.ref_musican_planning_ev_project.ref_associate.gDisp_Name_Firstname
            //}, row);
            let colProject = domConstruct.create("td", {
                innerHTML: entity.ref_musican_planning_ev_project.ref_ev_project.gDisp_1
            }, row);
            let colCostType = domConstruct.create("td", {
                innerHTML: entity.ref_musican_planning_ev_project_cost_entity_type.description
            }, row);
            let colKm = domConstruct.create("td", {
                innerHTML: entity.quantity_multiplier
            }, row);
            //let colCost = domConstruct.create("td", {
            //    innerHTML: entity.sum_employee_amount
            //}, row);

            sumKm += parseFloat(entity.quantity_multiplier);

            // Zeile mit den Formulareinträgen!
            let secondrow = domConstruct.create("tr", { "className": "w3-hide" }, table);
            let colTable = domConstruct.create("td", {
                innerHTML: "keine Einträge",
                "className": "subTableContainer",
                "colspan": "3"
            }, secondrow);

            if (entity.EL_TravelExpenses && entity.EL_TravelExpenses.length) {
                let subTable = new TravelExpenseList();
                subTable.set("targetColumn", entity._targetTravelExpensesColumn);
                subTable.set("buttons", false);
                subTable.set("sumrow", true);

                subTable.set("data", entity.EL_TravelExpenses);

                domConstruct.empty(colTable);
                domConstruct.create("h4", { "innerHTML": "Meine eingetragenen Daten" }, colTable);
                domConstruct.place(subTable.domNode, colTable);

                domClass.add(row, "clickable");
                domClass.add(secondrow, "w3-hide w3-border");
                on(row, "click", lang.hitch(this, this._onClickSubtableRow, row, secondrow));
            }

            //costSum += parseFloat(entity.sum_employee_amount);
        }
        let summary = domConstruct.create("tr", {}, table);
        let colEmpty = domConstruct.create("td", {}, summary);
        let colInfo = domConstruct.create("td", { innerHTML: "Summe:" }, summary);
        domClass.add(colInfo, "w3-right-align");
        let colSummary = domConstruct.create("td", { innerHTML: sumKm }, summary);

    }

    _onClickSubtableRow(clickedRow: any, targetNode: any): void {
        domClass.toggle(targetNode, "w3-hide");
        domClass.toggle(clickedRow, "clicked");
    }


    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
TravelExpenseTable.prototype.declaredClass = 'WidgetCollection.SOV.legacy.TravelExpenses.TravelExpenseTable';

export default mdsWidget(TravelExpenseTable);
